export default __webpack_public_path__ + "static/media/property_723.953eb0df.png";